
import { getCurrenciesSymbol } from '../services/base-service';
import { Component, Vue } from 'vue-property-decorator';

const defaultCurrencySymbol = '€'

interface ICurrencies {
  code: string,
  enabled: boolean,
  symbol: string
}

@Component({})
export default class CurrencyPipeMixin extends Vue {

  private projectCurrencies = [] as ICurrencies[];


  getReletedCurrency(currency?: string) {
    if (!currency) 
      return defaultCurrencySymbol

    const selectedSymbol = 
    this.projectCurrencies
      .find((cur: ICurrencies) => cur.code === currency);
    
    const symbol = (selectedSymbol && 
      selectedSymbol.hasOwnProperty('symbol')) ?
      selectedSymbol.symbol : defaultCurrencySymbol

    return symbol
  }

  formatMultiCurrencies(price: number | string, currency?: string) {
    if (typeof price == 'string') {
      price = Number(price);
    }
    if (price == null || isNaN(price)) {
      return '-';
    }
    const currencySymbol = this.getReletedCurrency(currency)
  return `${currencySymbol} ${price}`
}

async mounted() {
  const res = await getCurrenciesSymbol();
  if (res)
    this.projectCurrencies = res
}

}//